export const drawerContainerStyles = (open, drawerBleeding) => {
    return {
        position: 'absolute',
        top: -drawerBleeding,
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        visibility: 'visible',
        right: 0,
        left: 0,
        bgcolor: 'white',
        height: drawerBleeding,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        cursor: !open ? 'pointer' : 'default',
        borderTop: '1px solid',
        borderColor: 'divider',
        boxShadow: '0px -4px 12px rgba(0, 0, 0, 0.08)',
        zIndex: 10,
        userSelect: 'none',
        overflow: 'hidden',
    }
}

export const drawerHeaderStyles = (headerHeight) => {
    return {
        height: headerHeight,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
    }
}